import React, { useState, useEffect } from "react";
import { Form, Input, Spin, Button, App } from "antd";
import GoogleLoginButton from "../../shared/Authentication/GoogleLoginButton";
import FacebookLoginButton from "components/shared/Authentication/FacebookLoginButton";
import { Helmet } from "react-helmet";
import AppleLoginButton from "components/shared/Authentication/AppleLoginButton";

const onFinishFailed = (errorInfo) => {
};

const onGoogleLoginFinish = (props, data) => {
  const { loginUser } = props;
  let values = {
    userNameOrEmail: data.email,
    password: data.googleId,
    first_name: data.name,
    last_name: data.name,
    provider: "google",
  };
  loginUser(values).then(() => {});
};

/** Payload from FacebookLoginButtonNew: email/name from Graph profile, userID from authResponse. */
const onFacebookLoginFinish = (props, data) => {
  if (!data?.userID) return;

  const { loginUser } = props;

  const values = {
    userNameOrEmail: data.email,
    password: data.userID,
    first_name: data.name ?? "",
    last_name: "",
    provider: "facebook",
  };

  loginUser(values).then(() => {});
};

const onAppleLoginFinish = (props, data) => {
  const { loginUser } = props;

  const idToken = data?.authorization?.id_token;

  if (!idToken) return;

  const values = {
    id_token: idToken,
    provider: "apple",
  };

  loginUser(values).then(() => {});
};

const Login = (props) => {
  const { history, loading } = props;
  const [form] = Form.useForm();

  const onFinish = (props, values) => {
    const { loginUser } = props;
    values.first_name = null;
    values.last_name = null;
    loginUser(values).then((token) => {});
  };

  return (
    <div className="login-page-wrap">
      <Helmet>
        <title>
          Sign-In | Welcome To icause: Online Giving and Donation Platform
        </title>
        <meta
          name="description"
          content="Sign in to icause to start an online fundraiser, track your current campaign or donate to your favourite cause or charity. Log in or sign up to get started!"
        />
        <link rel="canonical" href={"https://icause.com.au/auth/login#!"} />
      </Helmet>

      <section className="sign-up-page login-page">
        <div className="container place-text">
          <div className="row">
            <div className="col-xl-7 col-lg-8 col-md-12 mx-auto">
              <div className="row">
                <div
                  className={
                    true
                      ? "col-lg-6 col-md-7 forgot-btn mx-auto"
                      : "col-lg-12 col-md-12 forgot-btn"
                  }
                >
                  <div
                    className={
                      true ? "form-wraper" : "col-lg-12 col-md-12 form-wraper"
                    }
                  >
                    <h3 className="text-center">SIGN-IN</h3>
                    <p className="text-center">Welcome To ICause</p>
                    <Spin spinning={loading}>
                      <Form
                        form={form}
                        layout="vertical"
                        name="basic"
                        onFinish={(values) => onFinish(props, values, history)}
                        onFinishFailed={onFinishFailed}
                      >
                        <div className="form-group ">
                          <Form.Item
                            label="Username or Email"
                            name="userNameOrEmail"
                            rules={[
                              {
                                required: true,
                                message: "Please input username/email !",
                              },
                            ]}
                          >
                            <Input
                              className="form-control"
                              placeholder="Username or Email"
                            />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: "Please input password !",
                              },
                            ]}
                          >
                            <Input
                              type="password"
                              className="form-control"
                              placeholder="Type your password"
                            />
                          </Form.Item>
                          <Button
                            className="forgat-btn"
                            style={{ width: "100%", paddingTop: "8px" }}
                            type="link"
                            onClick={() =>
                              history.push("/auth/forgot/password")
                            }
                          >
                            Forgot Your Password ?
                          </Button>
                        </div>
                        <Form.Item>
                          <button
                            className="btn btn-success   text-uppercase mt-4 d-block w-100"
                            type="submit"
                          >
                            LOGIN
                          </button>
                        </Form.Item>
                        <p className="text-center my-text mt-3 already-acc">
                          Don't have an Account?
                          <span className="text-grn">
                            <Button
                              style={{
                                marginLeft: "0px",
                                paddingTop: "8px",
                                paddingLeft: "5px",
                              }}
                              type="link"
                              onClick={() => history.push("/auth/signup")}
                            >
                              Sign up
                            </Button>
                          </span>
                        </p>
                      </Form>
                    </Spin>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-5">
                  <div className="social-button">
                    <FacebookLoginButton
                      btnText={`Sign in with Facebook`}
                      onFinish={(data) =>
                        onFacebookLoginFinish(props, data, history)
                      }
                    />
                    <GoogleLoginButton
                      btnText={`Sign in with Google`}
                      onFinish={(data) =>
                        onGoogleLoginFinish(props, data, history)
                      }
                      onFinishFailed={onFinishFailed}
                    />
                    <AppleLoginButton
                      btnText={`Sign in with Apple`}
                      onFinish={(data) =>
                        onAppleLoginFinish(props, data, history)
                      }
                    />

                    <div className="text-mob">
                      {" "}
                      <span className="after-line">OR</span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
